var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus",
    clipPath: "url(#clip0_407_91045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6641 7.33329H8.66406V3.33329C8.66406 3.15648 8.59382 2.98691 8.4688 2.86189C8.34378 2.73686 8.17421 2.66663 7.9974 2.66663C7.82058 2.66663 7.65102 2.73686 7.52599 2.86189C7.40097 2.98691 7.33073 3.15648 7.33073 3.33329V7.33329H3.33073C3.15392 7.33329 2.98435 7.40353 2.85932 7.52855C2.7343 7.65358 2.66406 7.82315 2.66406 7.99996C2.66406 8.17677 2.7343 8.34634 2.85932 8.47136C2.98435 8.59639 3.15392 8.66663 3.33073 8.66663H7.33073V12.6666C7.33073 12.8434 7.40097 13.013 7.52599 13.138C7.65102 13.2631 7.82058 13.3333 7.9974 13.3333C8.17421 13.3333 8.34378 13.2631 8.4688 13.138C8.59382 13.013 8.66406 12.8434 8.66406 12.6666V8.66663H12.6641C12.8409 8.66663 13.0104 8.59639 13.1355 8.47136C13.2605 8.34634 13.3307 8.17677 13.3307 7.99996C13.3307 7.82315 13.2605 7.65358 13.1355 7.52855C13.0104 7.40353 12.8409 7.33329 12.6641 7.33329Z",
    fill: "#B30000"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_91045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedplus);
export default __webpack_public_path__ + "static/media/red plus.40edfef68b2a89c2ee3744e0f8963d2c.svg";
export { ForwardRef as ReactComponent };